module.exports = BrowserFS.BFSRequire('buffer');



//////////////////
// WEBPACK FOOTER
// ./~/browserfs/dist/shims/buffer.js
// module id = 29
// module chunks = 0